export default __webpack_public_path__ + "static/media/leave-activity.3a6113b8.svg";